import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import TechSidebar from "../../components/sidebar/techSidebar";
import { Card } from "antd";
import ContentData from "./content";
import "../workOrder/index.css";
import {
  taskList,
  IndividualTask,
  answerTask,
  searchTask,
} from "../../functions/task";
import { useCan } from "../../utils/permissions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../components/toolkit/loader";

const Index = () => {
  const can = useCan()
  const canReadAnswer = can("answer", "read");
  const [ndata, setNdata] = useState([]);
  const [orderId, setOrderId] = useState("");
  const [tranId, setTranId] = useState("");
  const [isVisibleTech, setIsVisibleTech] = useState(false);
  const [activeEdit, setActiveEdit] = useState(false);
  const [individualTask, setIndividualTask] = useState("");
  const [pageC, setPageC] = useState(1);
  const [totaltech, setTotaltech] = useState("");
  const dispatch = useDispatch();
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [updateData, setUpdateData] = useState("");
  const [searchSurveyData, setSearchSurveyData] = useState("");
  const [customFields, setCustomFields] = useState([]);

  const clickHandler = async (t, tranIdVal, i) => {
    if (!t || !tranIdVal) { return }


    setActiveEdit(false);
    setSelectedCardIndex(i);
    dispatch(loaderReducer(true));
    console.log("clickHandler", t, tranIdVal);

    try {
      try {
        const individualTaskResponse = await IndividualTask(t);
        setIndividualTask(individualTaskResponse.data.data.task);
      } catch (err) {
        console.log(err);
      }
      //2nd api
      try {
        if (!canReadAnswer) return;
        const answerTaskResponse = await answerTask(t);
        setCustomFields(answerTaskResponse.data.answer);
        // console.log("answerTaskResponse=>", answerTaskResponse.data.answer);
      } catch (err) {
        console.log("err=>>", err);
      }

      // Set transaction ID and order ID
      setTranId(tranIdVal);
      setOrderId(t);
      dispatch(loaderReducer(false));
    } catch (error) {
      console.error("Error occurred:", error);
      dispatch(loaderReducer(false));
    }
  };

  const fetchFirstAnswer = async () => {
    if (!canReadAnswer) return;
    dispatch(loaderReducer(true));
    try {
      await answerTask(ndata[0]?._id)
        .then((res) => {
          setSelectedCardIndex(0);
          setCustomFields(res?.data?.answer);
          dispatch(loaderReducer(false));
          // console.log("fetchFirstAnswer?.data?.answer", res?.data?.answer);
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          toast.error(err);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error);
    }
  };

  useEffect(() => {
    if (ndata.length > 0) {
      fetchFirstAnswer();
    }
  }, [ndata[0]?._id]);

  useEffect(() => {
    clickHandler(updateData._id, updateData.tranId);
    setSelectedCardIndex(0);
  }, [updateData]);

  // useEffect(() => {
  //   if (ndata.length > 0) {
  //     setOrderId(ndata[0].order_id);
  //   }
  // }, [ndata]);

  // fetch All sidebar data--------------------------------------------------------

  const fetchData = async () => {
    dispatch(loaderReducer(true));
    try {
      await taskList(pageC)
        .then((res) => {
          // console.log("taskList=>", res);
          dispatch(loaderReducer(false));
          setNdata(res.data.data);
          setTotaltech(res.data.total);
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          toast.error(err);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error || "Getting some issue, try again.");
    }
  };

  //searchData-----------------------------------------------
  const searchTaskData = async () => {
    dispatch(loaderReducer(true));
    try {
      await searchTask(searchSurveyData, pageC)
        .then((res) => {
          dispatch(loaderReducer(false));
          setNdata(res.data.data);
          setTotaltech(res.data.total);

        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          console.log(err);
        });
    } catch (error) {
      dispatch(loaderReducer(false));
      console.log(error);
    }
  };

  useEffect(() => {
    if (searchSurveyData.length > 0) {
      searchTaskData();
    }
    if (searchSurveyData.length === 0) {
      fetchData();
    }
  }, [pageC, searchSurveyData]);

  useEffect(() => {
    if (ndata.length > 0) {
      setIndividualTask(ndata[0]);
    }
  }, [ndata]);

  const handleClickTech = () => {
    setIsVisibleTech(!isVisibleTech);
  };

  const handleActiveEdit = (e) => {
    setActiveEdit(!activeEdit);
  };

  const sidebarData = () =>
    ndata.map((d, i) => (
      <div
        className={`mt-3 ${selectedCardIndex === i ? "selected-card" : ""}`}
        key={i}
      >
        <Card
          hoverable
          // style={{ height: "10rem" }}
          className="cardcls"
          onClick={() => clickHandler(d?._id, d.tranId, i)}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="prioritycls text-dark p-0">{`${d.device}`}</div>
            <div className="prioritycls" style={{ color: "#1C449C" }}>
              Order #{d.tranId}
            </div>
          </div>
          <div className="mt-2">
            Tech: {d?.techName === null ? "No tech" : d?.techName}
          </div>
          <div className="mt-2">
            <div>
              Device: {d.serialNumber === "" ? "No device" : d.serialNumber}
            </div>
          </div>
        </Card>
      </div>
    ));

  //handle Action Without Saving
  const handleActionWithoutSaving = async () => {
    handleActiveEdit();
  };

  // useEffect(() => {
  //   handleActionWithoutSaving();
  // }, [updateData]);

  // console.log("ndata", ndata[0]?._id, "</>", customFields);

  return (
    <Layout
      sidebarContent={
        <TechSidebar arg={{ pageC, setPageC, totaltech, setSearchSurveyData }}>
          {sidebarData()}
        </TechSidebar>
      }
    >
      <div className="contentclss">
        <div className="ordercls">Order {individualTask.tranId}</div>
        <div className="sub2container mt-4">
          <ContentData
            setIndividualTask={setIndividualTask}
            arg={{
              isVisibleTech,
              activeEdit,
              handleClickTech,
              handleActiveEdit,
              individualTask,
              setUpdateData,
              updateData,
              handleActionWithoutSaving,
              setActiveEdit,
              customFields,
              setCustomFields,
              ndata,
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Index;
